import React, {useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import SearchLookupMaintenance from './SearchLookupMaintenance';
import AddLookupMaintenance from './AddLookupMaintenance/AddLookupMaintenance';
import {LOOKUP_MAINTENANCE} from '../../constants/ReusableRoleAccess';
import {useSelector} from 'react-redux';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    borderRadius: '5px',
  },
  padding: {
    padding: theme.spacing(3),
  },
  demo1: {
    backgroundColor: '#296bff',
    color: 'white',
    borderRadius: '6px',
  },
}));

export default function LookupMaintenanceTabs() {
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const [rowData, setRowData] = useState('');

  const {roleData} = useSelector(({role}) => role);
  const LookupMaintenanceAccess = roleData?.window?.[LOOKUP_MAINTENANCE]?.['LUM'];

  return (
    <div className={classes.root}>
      <div className={classes.subContent}>
        {value === 0 ? (
          <SearchLookupMaintenance
            setValue={setValue}
            setRowData={setRowData}
            LookupMaintenanceAccess={LookupMaintenanceAccess}
          />
        ) : null}
      </div>
      <div className={classes.subContent}>
        {value === 1 ? (
          <AddLookupMaintenance
            setValue={setValue}
            rowData={rowData}
            LookupMaintenanceAccess={LookupMaintenanceAccess}
          />
        ) : null}
      </div>
    </div>
  );
}
